import * as Sentry from '@sentry/browser';

function init() {
    const config = window?._kitchen_sentry ?? {};
    const dsn = config?.dsn;
    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        sendDefaultPii: config?.send_default_pii ?? false,
        release: 'neo-kitchen@1.0.0',
    });
}

init();
